import http from './httpService';
import {BASE_RESOURCE_URL} from "../utils/const";
import * as Axios from "axios";
import {t} from "react-switch-lang";

export function getAllFindings() {
    return http.get(`/findings`);
}
export function getAllFindingsDashboard(activeTab) {
    return http.get(`/findings?status.equals=${activeTab}`);
}
export function getSingleFinding(id) {
    return http.get(`/findings/${id}`);
}

export function addFinding(data) {
    return http.post(`/findings`, data);
}

export function deleteFinding(id) {
    return http.delete(`/findings/${id}`);
}

export function editFinding(id,data) {
    return http.put(`/findings/${id}`, data);
}


export function addRemark(formData){
   return  http.post(`/remarks?sort`, formData,{'Content-Type': 'multipart/form-data'});
}

export function getAllRemarks(findingId,pageNumber){
   return http.get(`/remarks?findingId=${findingId}&page=${pageNumber}&sort=createdAt,desc`);
}

export function getRemarkAttachedFile(file){
    return http.get(
        `${BASE_RESOURCE_URL}/api${file.downloadableLink}`,
        {
            responseType: "blob",
        }
    )
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", file.fileName);
            document.body.appendChild(link);
            link.click();
        });
}

export function getAudits(findingId,pageNumber){
    return http.get(`/finding-audits?sort=insertedAt,desc&findingId.equals=${findingId}&paged=true&page=${pageNumber}`)
}
export function getAllResponsibleUsers(id) {
  return http.get(`/users/audit-responsible?sort=firstName&id.notIn=${id}`);
}
export function getAllInvolvedUsers(id,departmentIds) {
  return http.get(`/users/audit-responsible??page=1&size=20&paged=true&sort=firstName&id.notEquals=${id}&departmentId.in=${departmentIds}`);
}
export function getAllResponsibleUsersData(departmentIds=[]) {
  return http.get(`/users/audit-responsible?page=1&size=20&paged=true&sort=firstName&departmentId.in=${departmentIds}`);
}
